import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { getHeaderCellStyles } from '../../../../../../reports/utils/getHeaderCellStyles'

export const NestedHeaderCell = styled.th`
  text-align: center;
  padding: ${Spacing.S8} ${Spacing.S24};
  box-shadow: 0 1px 0 0 ${Color.Grey150};
  background-color: ${Color.White};
  position: relative;
  width: 120px;

  /* Border that works with overflow */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 1px;
    height: 100%;
    background-color: ${Color.Grey150};
  }

  &[colspan]::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 1px;
    width: 100%;
    background-color: ${Color.Grey150};
  }
`

export const HeaderCell = styled.th`
  ${getHeaderCellStyles()}}
`
